import { Box } from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers";
import type { PickersDayProps } from "@mui/x-date-pickers";
import { isSameDay, parseISO } from "date-fns";

import type { AppointmentV1 } from "api/services/appointment/schemas/appointment_v1";

export interface BookedDayProps extends PickersDayProps<Date> {
  appointmentsV1?: AppointmentV1[];
}

export const BookedDay: React.FC<BookedDayProps> = ({
  appointmentsV1 = [],
  day,
  outsideCurrentMonth,
  ...pickersDayProps
}) => {
  const isBooked = !outsideCurrentMonth && appointmentsV1.some(call => isSameDay(parseISO(call.start_time), day));

  return (
    <Box sx={{ position: "relative", display: "inline-flex", flexDirection: "column", alignItems: "center" }}>
      <PickersDay {...pickersDayProps} day={day} outsideCurrentMonth={outsideCurrentMonth} />
      {isBooked && (
        <Box
          sx={{
            position: "absolute",
            bottom: 2,
            width: 4,
            height: 4,
            borderRadius: "50%",
            bgcolor: "primary.main",
          }}
        />
      )}
    </Box>
  );
};
